class RainaCartEnhancements {
  constructor() {
    this.sticky = document.querySelector('[data-raina-cart-sticky]');
    this.checkout = document.querySelector('#checkout');
    this.note = document.querySelector('#Cart-note');
    this.count = document.querySelector('[data-raina-note-count]');
    this.initNote();
    this.initSticky();
  }

  initNote() {
    if (!this.note || !this.count) return;
    const update = () => { this.count.textContent = `${this.note.value.length} / 500`; };
    this.note.maxLength = 500;
    this.note.addEventListener('input', update);
    update();
  }

  initSticky() {
    if (!this.sticky || !this.checkout || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => {
      this.sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.1 });
    observer.observe(this.checkout);
  }
}

document.addEventListener('DOMContentLoaded', () => new RainaCartEnhancements());
